import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  constructor(private router: Router,
              public authService: AuthService) { }

  ngOnInit(): void {
  }

  navigateUrl(value: 'police' | 'vacantion' | 'login' | 'chat') {
    if( value === 'police') {
      window.location.href = 'https://www.zakonrf.info';
    }
    if (value === 'vacantion') {
      window.location.href = 'https://irkzan.ru/vacancy/';
    }
    if (value === 'chat') {
      this.router.navigate(['chat']);
    }

    if (value === 'login') {
      this.router.navigate(['login']);
    }
  }
}
